import { registerLocaleData } from '@angular/common';
import localeDutch from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeFinnish from '@angular/common/locales/fi';
import localeNorwegian from '@angular/common/locales/nb';
import localeNatherland from '@angular/common/locales/nl';
import { Injectable } from '@angular/core';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { ThemesService } from 'projects/Autofacets-Core/src/app/services/themes.service';
import { SecureStorage } from '../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Constant } from '../../../../../Autofacets-Core/src/app/utils/constant';
import { CultureCodes, CurrencyCodes } from '../../../../../Autofacets-Core/src/app/utils/enums';
import { CommonLocalizationService } from '../localization/common-localization.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { ClientAppToken, EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { environment } from 'projects/StatusTracker/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CultureLocaleService {

  constructor(
    private commonLocalizationService: CommonLocalizationService,
    private secureStorage: SecureStorage,
    private themservice: ThemesService,
    private currentLanguage: CurrentLanguage,
    private globalSetting: GlobalSetting
  ) { }

  private _locale: string;
  private cultureCode: string;
  public currencyCode: string;
  globalizationValues: any;

  async initialise() {
    this.cultureCode = Constant.defaultISOCultureCode;
    EnvSetting.BRAND_API_URL = `${environment.STATUS_TRACKER_API_URL}AppSettings/BrandLogo`;
    EnvSetting.VIEW_IMAGE_API_URL = `${environment.STATUS_TRACKER_API_URL}Document/View`;
    if (ClientAppToken()) {
      await this.commonLocalizationService.GetSettings().then(async (res) => {
        await this.LoadConfig(res.responseObject);
      });
    }
    else {
      await this.commonLocalizationService.GetGenericSettings().then(async (res) => {
        await this.LoadConfig(res.responseObject);
      });
    }
  }

  private async LoadConfig(response: any) {
    if (response) {
      this.globalizationValues = response;
      if (this.globalizationValues && this.globalizationValues.length > 0) {
        let fromEnvironment = [{
          "property": "colorCode",
          "value": environment.ColorCode,
          "isDisplay": false
        }, {
          "property": "PUSH_NOTIFICATION_API_URI",
          "value": environment.PUSH_NOTIFICATION_API_URI,
          "isDisplay": false
        }, {
          "property": "STATUS_TRACKER_BASE_API_URL",
          "value": environment.STATUS_TRACKER_API_URL,
          "isDisplay": false
        }, {
          "property": "Tracker_CookieScript_Key",
          "value": environment.Tracker_CookieScript_Key,
          "isDisplay": false
        }]

        this.globalizationValues = [...this.globalizationValues, ...fromEnvironment];
        this.globalSetting.MapAppSetting(this.globalizationValues);
        let LicencePlateClass = this.globalizationValues.filter(x => x.property === 'LicencePlateClass');
        this.secureStorage.setKeyData('LicencePlateClass', LicencePlateClass[0].value);
        let tenant = this.globalizationValues.filter(x => x.property === 'Tenant');
        localStorage.setItem('Theme', tenant[0].value);
        let cultureCodeValue = this.globalizationValues.filter(x => x.property === 'CultureCode');
        this.secureStorage.setKeyData('LogoUrlLink', environment.LogoUrlLink);

        if (cultureCodeValue) {
          this.cultureCode = cultureCodeValue[0].value;
          this.currentLanguage.cultureCodeSubject.next(cultureCodeValue[0].value);
          this.secureStorage.setKeyData('CultureCode', cultureCodeValue[0].value);
        }
        if (tenant && tenant[0].value) {
          this.themservice.themeInitializer();
        }
        this.registerCulture(this.cultureCode);
        this.currencyCode = this.getCurrencyCode(this.cultureCode);
      }
    }
  }


  getLocale(): string {
    return this._locale || 'en';
  }

  registerCulture(culture: string) {
    switch (culture) {
      case CultureCodes.NB_NO: {
        this._locale = 'no';
        registerLocaleData(localeNorwegian, 'no');
        break;
      }
      case CultureCodes.FI_FI: {
        this._locale = 'fi';
        registerLocaleData(localeFinnish, 'fi');
        break;
      }
      case CultureCodes.NL_NL: {
        this._locale = 'nl';
        registerLocaleData(localeNatherland, 'nl');
        break;
      }
      case CultureCodes.DE_DE: {
        this._locale = 'de';
        registerLocaleData(localeDutch, 'de');
        break;
      }
      case CultureCodes.EN_US:
      default: {
        this._locale = 'en';
        registerLocaleData(localeEn, 'en');
        break;
      }
    }
  }

  getCurrencyCode(cultureCode: string): string {
    let code = '';
    switch (cultureCode) {
      case CultureCodes.EN_US:
        code = CurrencyCodes.USD;
        break;
      case CultureCodes.NL_NL:
        code = CurrencyCodes.EUR;
        break;
      case CultureCodes.NB_NO:
        code = CurrencyCodes.NOK;
        break;
      case CultureCodes.FI_FI:
        code = CurrencyCodes.EUR;
        break;
      case CultureCodes.DE_DE:
        code = CurrencyCodes.EUR;
        break;
      default:
        code = CurrencyCodes.USD;
    }
    return code;
  }
}
